export default "__VITE_ASSET__2mPG4qqb__"